export const EmailRegExp = /^[a-z0-9._-]+@[a-z0-9.-]{2,}[.][a-z0-9]{2,}$/i;
